import { render, staticRenderFns } from "./OverlayAbsolute.vue?vue&type=template&id=6b632d2a&scoped=true"
import script from "./OverlayAbsolute.vue?vue&type=script&lang=js"
export * from "./OverlayAbsolute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b632d2a",
  null
  
)

export default component.exports